export interface Testimonial {
  id: string;
  quote: string;
  name: string;
  role: string;
  initials: string;
  initialsBg: string;
  course: string;
  rating: number;
}

export const testimonials: Testimonial[] = [
  {
    id: '1',
    quote: "The AI Agents course transformed how I think about automation. Shipped my first agent to production in a week.",
    name: 'Jordan Kim',
    role: 'Software Engineer at Stripe',
    initials: 'JK',
    initialsBg: 'bg-primary-500',
    course: 'AI Agents & Automation',
    rating: 5,
  },
  {
    id: '2',
    quote: "ML Foundations is the best intro course I've taken. The intuition-first approach makes the math click.",
    name: 'Priya Mehta',
    role: 'Data Scientist at Netflix',
    initials: 'PM',
    initialsBg: 'bg-accent-500',
    course: 'Machine Learning Foundations',
    rating: 5,
  },
  {
    id: '3',
    quote: "ChatGPT Mastery 10x'd my productivity. I now delegate entire workflows to AI that used to take hours.",
    name: 'Tom Weston',
    role: 'Product Manager at Notion',
    initials: 'TW',
    initialsBg: 'bg-primary-600',
    course: 'ChatGPT Mastery',
    rating: 5,
  },
  {
    id: '4',
    quote: "AI for Developers gave me the confidence to integrate LLMs into my product. The RAG section alone was worth it.",
    name: 'Aisha Okonkwo',
    role: 'Founder, AI startup',
    initials: 'AO',
    initialsBg: 'bg-secondary-500',
    course: 'AI for Developers',
    rating: 5,
  },
];